export const calculatePageSizeOptions = (tableRows: number): number[] => {
    if (tableRows <= 10) {
        return [];
    } else if (tableRows > 10 && tableRows <= 20) {
        return [10, 20];
    }
    return [10, 20, 30];
};
